export default __webpack_public_path__ + "static/media/rdig_logo_cal.ab5733a9.jpg";